var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoinConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1673 12.6836C19.5125 12.6836 19.7923 12.9634 19.7923 13.3086C19.7923 16.8788 16.9042 19.7669 13.334 19.7669C13.1088 19.7669 12.9011 19.6458 12.7901 19.4499C12.6792 19.2539 12.6822 19.0134 12.7981 18.8204L13.6731 17.362C13.8506 17.066 14.2346 16.9701 14.5305 17.1477C14.8265 17.3253 14.9225 17.7092 14.7449 18.0052L14.5188 18.382C16.8264 17.8466 18.5423 15.7807 18.5423 13.3086C18.5423 12.9634 18.8221 12.6836 19.1673 12.6836Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48248 1.56854C3.1749 2.1039 1.45898 4.16978 1.45898 6.64193C1.45898 6.9871 1.17916 7.26693 0.833984 7.26693C0.488806 7.26693 0.208984 6.9871 0.208984 6.64193C0.208984 3.07175 3.09714 0.183594 6.66732 0.183594C6.89249 0.183594 7.10025 0.304714 7.21119 0.500657C7.32213 0.6966 7.3191 0.937072 7.20325 1.13015L6.32825 2.58849C6.15066 2.88447 5.76675 2.98045 5.47076 2.80286C5.17477 2.62527 5.07879 2.24135 5.25638 1.94537L5.48248 1.56854Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M12.3751 12.7745C12.3751 15.6162 10.0751 17.9162 7.23347 17.9162C4.3918 17.9162 2.0918 15.6162 2.0918 12.7745C2.0918 9.93285 4.3918 7.63281 7.23347 7.63281C7.3668 7.63281 7.4918 7.64116 7.63347 7.6495C10.1585 7.84116 12.1751 9.85782 12.3668 12.3828C12.3668 12.5078 12.3751 12.6328 12.3751 12.7745Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M17.9161 7.22564C17.9161 10.0673 15.6161 12.3673 12.7745 12.3673H12.3661C12.1745 9.84234 10.1578 7.82563 7.63281 7.63396V7.22564C7.63281 4.38397 9.93281 2.08398 12.7745 2.08398C15.6161 2.08398 17.9161 4.38397 17.9161 7.22564Z",
    fill: "#FCFCFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M9.26758 12.5076C9.36758 12.2992 9.42591 12.0742 9.42591 11.8326C9.42591 10.9992 8.69258 10.2659 7.85925 10.2659H7.64258V9.94922C7.64258 9.60755 7.35924 9.32422 7.01758 9.32422C6.67591 9.32422 6.39258 9.60755 6.39258 9.94922V10.2659H5.51758C5.17591 10.2659 4.89258 10.5492 4.89258 10.8909V12.7659V14.6409C4.89258 14.9826 5.17591 15.2659 5.51758 15.2659H6.39258V15.5826C6.39258 15.9242 6.67591 16.2076 7.01758 16.2076C7.35924 16.2076 7.64258 15.9242 7.64258 15.5826V15.2659H8.19258C9.12591 15.2659 9.89258 14.5659 9.89258 13.6992C9.89258 13.2242 9.64258 12.7909 9.26758 12.5076ZM6.14258 11.5159H7.85925C8.03425 11.5159 8.17591 11.7076 8.17591 11.8326C8.17591 12.0076 8.03425 12.1492 7.85925 12.1492H6.14258V11.5159ZM8.19258 14.0242H6.13425V13.3992H7.85091H8.18425C8.45091 13.3992 8.63425 13.5659 8.63425 13.7159C8.63425 13.8659 8.45925 14.0242 8.19258 14.0242Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinConvert);
export default __webpack_public_path__ + "static/media/bitcoin-convert.9ac1799c96af97a4ed547ee82ce7952f.svg";
export { ForwardRef as ReactComponent };